export default __webpack_public_path__ + "static/nextjs-191193428e34f9117b8d347edbd56ac9.png";